import { MenuSubMenu as SubMenu, ThemeComponentSwitcher } from 'lib_ui-primitives';
Object.defineProperty(SubMenu, '_reactMenu', { value: 'MenuSubMenu', writable: false });
import Gl2025SubMenu from './SubMenu.gl2025';

let SwitchedComponent = ThemeComponentSwitcher([
    {
        theme: 'gl2025',
        component: Gl2025SubMenu
    },
    { component: SubMenu }
]);

export default SwitchedComponent;
